import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import HomeV3 from './components/home-v3';
import AdLoader from './components/ads/AdSlot';

class Root extends Component {
	render() {
		return (
			<div>
				<AdLoader></AdLoader>
				<Router>
					<div>
						<Switch>
							<Route path="/" component={HomeV3} />
						</Switch>
					</div>
				</Router>
			</div>
		);
	}
}

export default Root;

ReactDOM.render(<Root />, document.getElementById('nextpage'));
